export default "__VITE_ASSET__DKRk1BPC__"